var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStarOutline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 20 18",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.32704 7.79512c-.6451-.56063-.27159-1.63083.56022-1.6818l4.10808-.28876c.23768-.01698.45832-.16988.56023-.40773l1.56175-3.82226c.16975-.39074.52622-.59457.88268-.59457.3565 0 .713.20383.8827.59457l1.5618 3.82226c.0848.22087.3056.37371.5602.40773l4.1081.28876c.8318.05099 1.2052 1.12118.5602 1.6818l-3.2254 2.63308c-.1867.1529-.2716.4078-.2207.6626l.9676 3.9751c.1358.6456-.3395 1.1722-.8997 1.1722-.1698 0-.3395-.051-.4923-.1529l-3.5138-2.1575c-.2037-.1359-.47537-.1359-.67905 0l-3.47999 2.1575c-.15279.1019-.33951.1529-.50926.1529-.56023 0-1.06949-.5266-.89974-1.1722l.96758-3.9751c.05095-.2379-.01696-.4927-.22071-.6456z",
    stroke: "#fff",
    strokeMiterlimit: 16,
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStarOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star-outline.d29e696feafbab040d60eb0a579e081e.svg";